<template>
    <rkm-row>
        <rkm-col cols="12">

            <rkm-form-radio-group
                label="Nos últimos três meses, os alimentos acabaram antes que você tivesse dinheiro para comprar mais comida?"
                v-model="data.model.informacaoSocioeconomica.alimentosAcabaram"
                :validations="validations.alimentosAcabaram"
            >
                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                <rkm-form-radio :value="false">Não</rkm-form-radio>
                <rkm-form-radio
                    :value="null"
                >
                    Não informado
                </rkm-form-radio>
            </rkm-form-radio-group>
        </rkm-col>
        <rkm-col cols="12">

            <rkm-form-radio-group
                label="Nos últimos três meses, você comeu apenas alguns alimentos que ainda tinha, porque o dinheiro acabou?"
                v-model="data.model.informacaoSocioeconomica.comeuAlgunsAlimentos"
                :validations="validations.comeuAlgunsAlimentos"
            >
                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                <rkm-form-radio :value="false">Não</rkm-form-radio>
                <rkm-form-radio
                    :value="null"
                >
                    Não informado
                </rkm-form-radio>
            </rkm-form-radio-group>
        </rkm-col>
    </rkm-row>
</template>

<script>

export default {
    computed: {
        validations() {
            return {
                alimentosAcabaram: {
                    required: this.data.model.informacaoSocioeconomica.comeuAlgunsAlimentos !== null
                },
                comeuAlgunsAlimentos: {
                    required: this.data.model.informacaoSocioeconomica.alimentosAcabaram !== null
                },
            }
        },
    },
    props: {
        data: { type: Object, required: false, },
    }
}
</script>